const NotFound = () =>
  import(/* webpackChunkName: "notfound" */ '../layouts/Notfound.vue')
const ServerError = () =>
  import(/* webpackChunkName: "notfound" */ '../layouts/ServerError.vue')

const ErrorRoute = [
	{
		path: '/404-not-found',
		name: 'notfound',
		component: NotFound,
	},
	{
		path: '/server-error',
		name: 'servererror',
		component: ServerError,
	},
]

export default ErrorRoute
